// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"c3-z","colorTextValue":"d3-z","swatches":"e3-z","collapseLink":"f3-z","isCollapsed":"g3-z","dropdown":"h3-z","disabled":"i3-z"};